import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITermBC } from "src/models/Prices/TermBC.models";

interface TermBCState {
  termBCs: ITermBC[];
  termBCToEdit: ITermBC | null;
}

const initialState: TermBCState = {
  termBCs: [],
  termBCToEdit: null,
};

const TermBCSlice = createSlice({
  name: "TermBC",
  initialState,
  reducers: {
    setTermBCList: (state, action: PayloadAction<ITermBC[]>) => {
      state.termBCs = action.payload;
    },
    concatListTermBC: (
      state: TermBCState,
      action: PayloadAction<ITermBC[]>
    ) => {
      state.termBCs = [...state.termBCs.concat(action.payload)];
    },
    setTermBCToEdit: (state, action: PayloadAction<ITermBC | null>) => {
      state.termBCToEdit = action.payload;
    },
    addTermBC: (state, action: PayloadAction<ITermBC>) => {
      state.termBCs.push(action.payload);
    },
    updateTermBC: (state, action: PayloadAction<ITermBC>) => {
      let itemIndex = state.termBCs.findIndex(
        item => item.termBCId === action.payload.termBCId
      );
      if (itemIndex !== -1) state.termBCs[itemIndex] = action.payload;
    },
    deleteTermBC: (state, action: PayloadAction<number>) => {
      const newArray = state.termBCs.filter(
        item => item.termBCId !== action.payload
      );
      state.termBCs = newArray;
    },
  },
});

export const {
  setTermBCList,
  concatListTermBC,
  setTermBCToEdit,
  addTermBC,
  updateTermBC,
  deleteTermBC,
} = TermBCSlice.actions;

export default TermBCSlice.reducer;
